const GENERIC_CONTACT_ROLES = new Set(['employee', 'da email']);

export function isGenericContactRole(value: string | null | undefined): boolean {
  const normalized = String(value ?? '').trim().toLocaleLowerCase('it');
  return !normalized || GENERIC_CONTACT_ROLES.has(normalized);
}
